<div class="allergen-list" [ngClass]="'allergen-list--' + variant" *ngIf="allergens.length">
  <div class="allergen-list__title">{{ title | translate }}</div>
  <div class="allergen-list__items">
    <span class="allergen-list__item" *ngFor="let allergen of allergens">
      <app-allergen-icon [allergen]="allergen" [size]="16"></app-allergen-icon>
      {{ allergen | allergenTranslate }}
    </span>
  </div>
</div>
